<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong> {{ editing ? "Sửa" : "Xem chi tiết" }} {{ assetMutationCauseTypeName }}</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getSyncSourceType(assetMutationCause.syncSourceType) }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group :label="'Mã ' + assetMutationCauseTypeName + ':' "
                                              label-for="input-code"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              :label-class="editing? 'required' : ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-code"
                                                  class="col-md-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.assetMutationCause.code.$model"
                                                  v-if="editing"
                                                  :state="($v.assetMutationCause.code.$dirty? !$v.assetMutationCause.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.assetMutationCause.code.$error">
                                        Vui lòng nhập mã
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="!$v.assetMutationCause.code.$error && ($v.codeUnique.$error)">
                                        Mã {{ assetMutationCauseTypeName }} đã tồn tại
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ assetMutationCause.code }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group :label="'Tên ' + assetMutationCauseTypeName + ':' "
                                              label-for="input-name"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              :label-class="editing? 'required' : ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name"
                                                  class="col-md-6"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.assetMutationCause.name.$model"
                                                  v-if="editing"
                                                  :state="$v.assetMutationCause.name.$dirty? !$v.assetMutationCause.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập tên
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ assetMutationCause.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Loại lý do biến động:"
                                              :label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing? 'required' : ''">
                                    <div class="col-md-6 no-padding" v-if="editing">
                                        <b-form-input type="text" style="display: none"
                                                      v-model="$v.assetMutationCause.causeTypeId.$model"
                                                      :state="$v.assetMutationCause.causeTypeId.$error ? false : null"></b-form-input>
                                        <select2 placeholder="--- Chọn loại lý do ---"
                                                 v-if="assetMutationCauseTypes.length > 0"
                                                 v-model="assetMutationCause.causeTypeId"
                                                 v-bind:options="assetMutationCauseTypes"
                                                 :state="$v.assetMutationCause.causeTypeId.$dirty? !$v.assetMutationCause.causeTypeId.$error : null"></select2>
                                        <b-form-invalid-feedback id="unitTypeFeedback">
                                            Vui lòng chọn loại lý do biến động
                                        </b-form-invalid-feedback>
                                    </div>
                                    <label class="col-form-label" v-if="!editing">{{ assetMutationCause.causeTypeName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Loại tài sản áp dụng: "
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect v-if="editing" v-model="assetMutationCause.appliedAssetTypeGroupIds"
                                                multiple
                                                class="no-padding col-md-6"
                                                placeholder="--- Tất cả ---"
                                                :options="assetTypeGroups" />
                                    <label class="col-form-label" v-if="!editing">{{ (assetMutationCause.appliedAssetTypeGroupNames || []).join(', ') || 'Tất cả' }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Thứ tự hiển thị: "
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="number"
                                                  class="col-md-6"
                                                  v-model="assetMutationCause.displayOrder"
                                                  v-if="editing">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ assetMutationCause.displayOrder }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" label-cols="4" label-cols-md="3">
                                    <b-button type="submit" variant="primary" v-if="editing && authorize(['ManageAssetMutationCause']) && isBTCUser"> Lưu</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel" v-if="editing && !$route.meta.editing"> Quay lại</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '../' }"> Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'AssetMutationCauseDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                codeUnique: 'ok',
                assetMutationCause: {},
                editing: this.$route.meta.editing,
                flag: false,
            }
        },
        computed: {
            assetMutationCauseId() {
                return this.$route.params.assetMutationCauseId;
            },
            ...mapState({
                units: (state, getters) => getters.unitTree,
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
                assetMutationCauseTypes: function (state, getters) {
                    if (this.assetMutationCauseTypeIds == null) {
                        return state.common.assetMutationCauseTypes;
                    } else {
                        var vm = this;
                        return state.common.assetMutationCauseTypes.filter(x => vm.assetMutationCauseTypeIds.indexOf(parseInt(x.id)) != -1);
                    }
                }
            }),
            assetMutationCauseTypeIds() {
                return this.$route.meta.assetMutationCauseTypeIds;
            },
            assetMutationCauseTypeName() {
                if (this.assetMutationCauseTypeIds == null) {
                    return 'lý do biến động';
                } else if (this.assetMutationCauseTypeIds.indexOf(5) != -1) {
                    return 'lý do giảm';
                } else {
                    return 'lý do tăng';
                }
            },
        },
        watch: {
        },
        validations: {
            assetMutationCause: {
                code: { required },
                name: { required },
                causeTypeId: { required }
            },
            codeUnique: { required }
        },
        created() {
            this.loadAssetMutationCauseDetail();
        },
        methods: {
            loadAssetMutationCauseDetail() {
                var vm = this;
                return this.$services.get(`master-data/asset-mutation-causes/${this.assetMutationCauseId}`).done(assetMutationCause => {
                    vm.assetMutationCause = assetMutationCause;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '../' });
            },
            cancel() {
                var vm = this;
                this.loadAssetMutationCauseDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (vm.assetMutationCause.code != null && vm.assetMutationCause.code != '') {
                    vm.$services.get(`master-data/existing-asset-mutation-causes-code`, { id: vm.assetMutationCause.id || '', code: vm.assetMutationCause.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.put(`master-data/asset-mutation-causes/${vm.assetMutationCauseId}`, vm.assetMutationCause).done(() => {
                                    vm.$toastr.s(`Cập nhật ${this.assetMutationCauseTypeName} thành công`);
                                    vm.back();
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped>
</style>
